var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "88px",
    height: "88px",
    viewBox: "0 0 88 88",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/AMEX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/AMEX"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "BoundingBox",
    points: "0 0 88 0 88 88 72.2089844 88 0 88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.12509996,36.6666667 L14.8861643,36.6666667 L22.5713306,53.9918109 L22.5713306,36.6666667 L29.9778187,36.6666667 L35.9137059,49.0887101 L41.384325,36.6666667 L48.7538168,36.6666667 L48.7538168,55 L44.2696303,55 L44.2330362,40.6341071 L37.6955578,55 L33.6842798,55 L27.1102073,40.6341071 L27.1102073,55 L17.8852732,55 L16.1363962,50.8899065 L6.68787614,50.8899065 L4.94261834,54.9963936 L0,54.9963936 C0,54.9963936 8.12509996,36.6666667 8.12509996,36.6666667 Z M52.8563791,36.6666667 L71.0898996,36.6666667 L76.6666819,42.6693186 L82.4232177,36.6666667 L88,36.6666667 L79.5266527,45.881018 L88,54.9891808 L82.170276,54.9891808 L76.5934937,48.9168051 L70.8076021,54.9891808 L52.8563791,54.9891808 L52.8563791,36.6666667 L52.8563791,36.6666667 Z M11.4141469,39.7685711 L8.30123427,47.090364 L14.5234402,47.090364 L11.4141469,39.7685711 Z M57.3590638,40.4626027 L57.3590638,43.8093417 L67.306229,43.8093417 L67.306229,47.5395611 L57.3590638,47.5395611 L57.3590638,51.1932447 L68.5162475,51.1932447 L73.7005479,45.8116949 L68.7362144,40.459397 L57.3590638,40.459397 L57.3590638,40.4626027 Z",
    id: "Shape",
    fill: "#006FCF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAmex);
export default __webpack_public_path__ + "static/media/card-amex.d41a8343738006057a86ae0e147fdfd5.svg";
export { ForwardRef as ReactComponent };